module.exports = __webpack_public_path__ + "img/cobalagi.115b7039.png";